import { ReactElement } from 'react';
import { ClickAwayContextValue, ClickAwayProps } from './types';
import { useClickAway } from './useClickAway';

/**
 * Be aware of WHEN you call register and deregister function !!
 * - register - should be called after overlay/dropdown menu/dialog/tooltip is opened and NOT when component is mount
 * - deregister - should be called after overlay/dropdown menu/dialog/tooltip is closed OR component will unmount
 *
 * @deprecated use useClickAway instead
 */
export const ClickAwayContextConsumer = <P extends ClickAwayProps>({
    children,
}: {
    children: (value: ClickAwayContextValue) => ReactElement<P>;
}) => {
    const contextValue = useClickAway();
    return children(contextValue);
};
